/* eslint-disable prefer-promise-reject-errors,no-undef,no-unused-vars */
// import Noty from 'noty'
// import GoogleMapsLoader from 'google-maps'

// import {ImageResize} from 'quill-image-resize-module'
// import {ImageDrop} from 'quill-image-drop-module'
const bytesToSize = (bytes) => {
  let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (bytes === 0) return '0 Byte'
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
  return `${Math.round(bytes / Math.pow(1024, i), 2)} ${sizes[i]}`
}

const _b = require('bootstrap.native/dist/bootstrap-native-v4')

const docReady = () => {
  return new Promise((resolve, reject) => {
    document.addEventListener('DOMContentLoaded', (event) => {
      resolve(event)
    })
  })
}

const select = (elem, callback) => {
  return new Promise(resolve => {
    let el = elem
    if (typeof elem === 'string') {
      el = document.querySelectorAll(elem)
    }
    if (typeof el === 'object') {

      if (Object.keys(el).length > 0) {
        for (let item of el) {
          if (typeof callback === 'function') {
            callback(item)
          }
        }
        resolve(el)
      } else if (el instanceof HTMLElement) {
        if (typeof callback === 'function') {
          callback(el)
        }
        resolve(el)
      }
    }
  })
}

const event = (elem, event, callback) => {
  return new Promise(resolve => {

    select(elem, el => {
      let $evt = null
      if (typeof event === 'string') {
        $evt = [event]
      } else if (Array.isArray(event)) {
        $evt = event
      }
      for (let ev in $evt) {
        if ($evt.hasOwnProperty(ev)) {
          let e = $evt[ev]
          el.addEventListener(e, event => {
            if (typeof callback === 'function') {
              callback(event, el)
            }
          }, false)
        }
      }
      // el.addEventListener(event, evt => {
      //   if (typeof callback === 'function') {
      //     callback(evt, el)
      //   }
      // }, false)
    }).then(el => {
      resolve(el)
    })
  })
}

const getValue = (elem) => {
  let el = elem
  if (typeof elem === 'string') {
    el = document.querySelector(elem)
  }
  if (
    el !== null &&
    typeof el === 'object' &&
    el.value
  ) {
    return el.value
  }
  return null
}

const setValue = (elem, value) => {
  select(elem, el => {
    if (el.value) {
      el.value = value
    }
  })
}

// const dtTable = (params) => {
//   for (let elem of params) {
//     let defaultOptions = {
//       responsive: true,
//       language: {
//         lengthMenu: 'Voir _MENU_ enregistrements par page',
//         zeroRecords: 'Aucun enregistrement trouvé - sorry',
//         info: 'Enregistrement _PAGE_ sur _PAGES_',
//         infoEmpty: 'Aucun enregistrement disponible',
//         infoFiltered: '(filtered from _MAX_ total records)',
//         search: 'Rechercher',
//         paginate: {
//           next: 'suivant',
//           previous: 'précédent'
//         }
//       }
//     }
//     let options = {}
//     if (elem.options) {
//       options = Object.assign(defaultOptions, elem.options)
//     } else {
//       options = Object.assign(defaultOptions, {})
//     }
//     if (document.querySelector(elem.target) !== null) {
//       $(elem.target).DataTable(options)
//     }
//   }
// }

const resizeFromParent = (elem) => {
  for (let el of elem) {
    let target = document.querySelectorAll(el)
    if (target !== null) {
      for (let item of target) {
        if (item !== null) {
          item.style.width = `${item.parentNode.offsetWidth}px`
        }
      }
    }
  }
}

const formModal = (params) => {
// eslint-disable-next-line func-call-spacing
  return new Promise(resolve => {
    let defaultOptions = {
      modal: '#modal-attention',
      btnConfirm: '#delete-confirmation',
      titre: 'Attention',
      message: `Êtes vous sûr de vouloir supprimer cet élément ?`
    }
    let options = Object.assign(defaultOptions, params)
    let modalInstance = new _b.Modal(options.modal)
    if (options.btnConfirm === null) {
      options.btnConfirm = '#delete-confirmation'
    }
    let modal = document.querySelector(options.modal)
    modal.querySelector('.modal-title').innerHTML = options.titre
    modal.querySelector('.modal-body').innerHTML = options.message
    modalInstance.show()
    let confirmBtn = modal.querySelector(options.btnConfirm)
    confirmBtn.removeEventListener('click', {passive: true})
    confirmBtn.addEventListener('click', (evt) => {
      evt.stopPropagation()
      evt.preventDefault()
      resolve(true)
      modalInstance.hide()
    })
    let modalAttention = document.querySelector('#modal-attention')
    modalAttention.addEventListener('click', (evt) => {
      evt.stopPropagation()
      evt.preventDefault()
      resolve(false)
      modalInstance.hide()
    }, false)
    let btnUnconfirm = document.querySelector('#delete-unconfirm')
    btnUnconfirm.removeEventListener('click', {passive: true})
    btnUnconfirm.addEventListener('click', (evt) => {
      evt.stopPropagation()
      evt.preventDefault()
      resolve(false)
      modalInstance.hide()
    }, false)
  })
}

const modal = (params) => {
  let defaultOptions = {
    modal: '#modal-img',
    titre: ``,
    message: ``,
    img: ``
  }
  let options = Object.assign(defaultOptions, params)
  let modalInstance = new _b.Modal(options.modal)
  let modal = document.querySelector(options.modal)
  let image = ''
  if (options.image) {
    image = `<div class="text-center"><img src="${options.image}" class="img-fluid mx-auto"/></div>`
    modal.querySelector('.modal-body').innerHTML = image
  }
  modalInstance.toggle()
}

const clickToggleTarget = (elem) => {
  event(elem, 'click', evt => {
    evt.preventDefault()
    evt.stopPropagation()
    select(evt.target.dataset.target, target => {
      target.classList.toggle('hide')
    })
    // if (evt.target.classList.contains(elem.replace(/\./g, ''))) {}
  })
  // select(elem, el => {
  //   select(el.dataset.target, target => {
  //     console.log(target.classList)
  //   })
  // })
}

const readURL = (input) => {
  select(input, el => {
    let target = document.querySelector(el.dataset.target)
    let img = target.querySelector('img')
    if (img && img.hasAttributes('src')) {
      if (el.nextSibling.nextSibling instanceof HTMLLabelElement) {
        el.nextSibling.nextSibling.innerHTML = `<small class="text-muted">${el.dataset.file}</small>`
      }
    }
  })
  event(input, 'change', (evt, el) => {
    let file = el.files || el.dataTransfer.files
    let target = document.querySelector(el.dataset.target)
    if (file && file[0]) {
      let reader = new FileReader()
      reader.addEventListener('load', () => {
          let img = document.createElement('img')
          img.className += 'animated fadeIn img-fluid img-thumbnail'
          img.setAttribute('id', 'form-img')
          img.style.maxHeight = '500px'
          img.src = reader.result
          target.innerHTML = img.outerHTML
      }, false)
      reader.readAsDataURL(file[0])
      // console.log(file[0])
      if (file[0].size > 41943040) {
        import('@base/js/Notif').then(({Notif}) => {
          Notif({
            timeout: 10000,
            layout: 'topCenter',
            text: `
                    Votre fichier est trop volumineux (${bytesToSize(file[0].size)}),<br>
                    Il ne sera pas enregistré.<br>
                    Taille maximale: ${bytesToSize(41943040)}
                    `,
            type: 'error'
          }).show()
        })
      }
      if (el.nextSibling.nextSibling instanceof HTMLLabelElement) {
        el.nextSibling.nextSibling.innerHTML = `<small class="text-muted">${file[0].name}</small>`
      }
    }
  })
}

const inArray = (needle, haystack) => {
  for (let item in haystack) {
    if (item === needle) return true
  }
}

const getUri = () => {
  return document.location.href.split('/').pop()
}

const route = (pathName) => {
  return new Promise(resolve => {
    if (location.pathname.substr(1) === pathName) {
      resolve()
    }
  })
}

const getAttribute = (elem, attr) => {
  select(elem, el => {
    return el.getAttribute(attr)
  })
}

const closest = (el, selector) => {
  let matchesFn
  ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some((fn) => {
    if (typeof document.body[fn] === 'function') {
      matchesFn = fn
      return true
    } else {
      return false
    }
  })
  let parent
  // traverse parents
  while (el) {
    parent = el.parentElement
    if (parent && parent[matchesFn](selector)) {
      return parent
    }
    el = parent
  }
  return null
}


export {
  docReady,
  route,
  readURL,
  resizeFromParent,
  formModal,
  modal,
  select,
  event,
  clickToggleTarget,
  getValue,
  setValue,
  getUri,
  getAttribute,
  closest,
  inArray
}
